import { FormFieldModel, NumberFieldValidator } from '@alfresco/adf-core';

export class WkRequireApprovedPercentValidator extends NumberFieldValidator {
  validate(field: FormFieldModel): boolean {
    if (
      this.isSupported(field) &&
      field.isVisible &&
      field.id.includes('requiredApprovePercent')
    ) {
      if (
        field.value === null ||
        field.value === undefined ||
        field.value === ''
      ) {
        return true;
      }
      const valueStr = '' + field.value;
      const pattern = new RegExp(/^\d+$/);
      if (field.value > 100) {
        field.validationSummary.message =
          'Percentage value can not be greater than 100';
        return false;
      } else if (valueStr.match(pattern)) {
        return true;
      } else {
        field.validationSummary.message = 'Enter a whole number';
        return false;
      }
    }
    return true;
  }
}
